import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MoreCard from './MoreCard/MoreCard';
import ListItem from '@shared/ListItem/ListItem';
import classes from './More.module.scss';
import Slider from '@shared/Slider/Slider';
import { useSelector } from 'react-redux';
import { versionSelector } from '@store/models/user/selectors';
import { triggerMetricsEvent } from '@metrics';
import { moreCardList, titleConfig } from '@configs/more';
import { useWindowSize } from '@hooks/useWindowSize';
const More = () => {
    const version = useSelector(versionSelector);
    const { isMobile, isDesktop } = useWindowSize();
    const handleScroll = () => {
        triggerMetricsEvent({ element: 'moreCardsScroll' });
    };
    const title = titleConfig[version];
    const noteText = _jsx("p", { className: classes.noteText, children: "\u0421\u0435\u0440\u0432\u0438\u0441\u044B \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0438 \u043D\u0435\u00A0\u0442\u0440\u0430\u0442\u044F\u0442 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442" });
    const titleBlock = (_jsx("div", { className: classes.titleWrap, children: _jsx("h2", { className: classes.title, children: title }) }));
    const cards = moreCardList[version].map(el => (_jsx(ListItem, { className: classes.card, type: 'div', children: _jsx(MoreCard, { element: el }) }, el.name)));
    return (_jsxs("section", { className: classes.container, "data-testid": "more", children: [titleBlock, !isDesktop ? (_jsx(Slider, { className: classes.slider, slideClass: classes.slide, onScroll: handleScroll, children: cards })) : (cards)] }));
};
export default More;
